module.exports = __webpack_public_path__ + "static/media/home-company-bg_md.2d8e32f3.jpg";